import { CircleCheck } from "lucide-react";
import { applyAuth0Theme } from "@/utils/theme";
import { useResetPasswordSuccessManager } from "./hooks/resetPasswordSuccessManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function ResetPasswordSuccessScreen() {
    const { resetPasswordSuccess, texts, locales } = useResetPasswordSuccessManager();
    applyAuth0Theme(resetPasswordSuccess);

    const description = texts?.description || locales.header.description;

    return (
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>
            <div className="auth-view text-center">
                <div className="flex justify-center mb-6 mt-4 text-(--ul-theme-color-success)">
                    <CircleCheck size={80} strokeWidth={1} />
                </div>
                <p className="auth-code-prompt">
                    {description}
                </p>
            </div>
        </AuthLayout>
    );
}

export default ResetPasswordSuccessScreen;
